import React from 'react';

const RightChevron = () => (
  <svg
    className="icon icon-rightchevron"
    width="10px"
    height="18px"
    viewBox="0 0 10 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Modal_THD_MI" transform="translate(-161.000000, -318.000000)" fill="#009FD4">
        <g id="Group" transform="translate(157.000000, 317.000000)">
          <g id="Icons/Chevron/Left/Default" transform="translate(0.000000, 1.000000)">
            <path
              className="st0"
              d="M11.1159506,0.484848485 C11.4411435,0.161614545 11.8284998,0 12.2780312,0 C12.7275626,0 13.1244833,0.166665 13.4688052,0.5 C13.8131271,0.833335 13.9900676,1.21716955 13.9996321,1.65151515 C14.0091966,2.08586076 13.8322561,2.51514939 13.4688052,2.93939394 L7.95968216,9 L13.4688052,15.0606061 C13.8322561,15.4848506 14.0091966,15.9141392 13.9996321,16.3484848 C13.9900676,16.7828305 13.8131271,17.166665 13.4688052,17.5 C13.1244833,17.833335 12.7275626,18 12.2780312,18 C11.8284998,18 11.4411435,17.8383855 11.1159506,17.5151515 C10.5612097,16.92929 9.3752298,15.6363736 7.55797528,13.6363636 L4.48778693,10.2121212 C4.16259402,9.86868515 4,9.46464879 4,9 C4,8.53535121 4.16259402,8.13131485 4.48778693,7.78787879 L7.55797528,4.36363636 C9.3752298,2.36362636 10.5612097,1.07071 11.1159506,0.484848485 Z"
              id=""
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default RightChevron;
